<template>
  <div :class="['w-full flex flex-row justify-between', rootExtraClasses]">
    <InputRadio
      v-model="selectedRadio"
      :value="value"
      :label="label"
      :secondary-label="secondaryLabel"
      :group-name="groupName"
      :validate-on-value-update="validateOnValueUpdate"
    />
    <slot name="img"></slot>
  </div>
  <slot name="visible"></slot>
  <div
    v-if="
      (hiddenFieldWillStillRender === false && selectedRadio == value) ||
      hiddenFieldWillStillRender === true
    "
    :class="{ hidden: selectedRadio != value }"
  >
    <slot name="hidden"></slot>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  label?: string;
  secondaryLabel?: string;
  value?: string | {};
  groupName?: string;
  rootExtraClasses?: string;
  validateOnValueUpdate?: boolean;
  hiddenFieldWillStillRender?: boolean;
}

withDefaults(defineProps<Props>(), {
  label: '',
  secondaryLabel: undefined,
  value: '',
  groupName: 'radioknappar',
  rootExtraClasses: undefined,
  validateOnValueUpdate: true,
  hiddenFieldWillStillRender: false,
});

const selectedRadio = defineModel<string | {}>();
</script>

<style scoped lang="scss"></style>
